import React from 'react';
import PropTypes from 'prop-types';
import { size, get } from 'lodash';
import { FormInput, Button, Row, FlexContainer, HasPermissions, InputItemList } from '../../common';
import CreateABMPermission from '../../graphql/createABMPermission';
import { _get } from '../../../utils/misc';

class PermissionForm extends React.Component {
    state = {
        activeProduct: null,
        name: this.props.initialValues.name,
        roleName: this.props.initialValues.roleName,
        resources: this.props.initialValues.resources,
        loading: false
    }

    handleSubmit = () => {
        const { createGroup } = this.props;
        console.log('should submit', this.props);

        this.setState({ loading: true });
        createGroup({ variables: {
            input: {
                id: this.props.initialValues.id || this.state.roleName,
                roleName: this.state.roleName,
                name: this.state.name,
                resources: this.state.resources || []
            }
        }})
            .then((_) => {
                this.setState({ loading: false });
                this.props.onSubmitSuccess();
            })
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false });
            });
    }

    isDisabled = () => {
        return !(size(this.state.name, '') && size(this.state.roleName, ''))
    };

    render () {
        console.log({ editMode: this.props.editMode })
        return <FlexContainer style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <FormInput
                label='Nombre del módulo'
                value={this.state.name}
                placeholder={'Ingrese nombre'}
                onChange={({ target }) => this.setState({ name: get(target, 'value', '') })}
            />
            <FormInput
                label='Identificador del módulo'
                value={this.state.roleName}
                placeholder={'Ingrese identificador del rol (nombremodulo-page)'}
                onChange={({ target }) => this.setState({ roleName: get(target, 'value', '') })}
            />
            <InputItemList
                label='Permisos'
                placeholder='Ingrese permiso'
                data={this.state.resources}
                onChange={data => {this.setState({ resources: data })}}
            />
            <HasPermissions to={['permissions-page:edit']}>
                <Row justify='flex-end' mB={10} mT={40}>
                    <Button link text='Cancelar' width={100} onClick={this.props.onReset} />
                    <Button width={100} loading={this.state.loading} onClick={this.handleSubmit} disabled={this.isDisabled()}>Guardar</Button>
                </Row>
            </HasPermissions>
        </FlexContainer>
    }}

PermissionForm.defaultProps = {
    values: {},
    initialValues: {}
};

PermissionForm.propTypes = {
    editMode: PropTypes.bool,
    initialValues: PropTypes.object,
    createGroup: PropTypes.func,
    onSubmitSuccess: PropTypes.func
};

export default (props) => {
    return <CreateABMPermission>
        {({ updateFn }) => (
            <PermissionForm createGroup={updateFn} {...props} />
        )}
    </CreateABMPermission>
};
